import { render, staticRenderFns } from "./navigation-footer.vue?vue&type=template&id=661a145e&scoped=true&"
import script from "./navigation-footer.vue?vue&type=script&lang=ts&"
export * from "./navigation-footer.vue?vue&type=script&lang=ts&"
import style0 from "./navigation-footer.vue?vue&type=style&index=0&id=661a145e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a145e",
  null
  
)

export default component.exports